import React, { useState, useEffect, useMemo } from 'react';
import { Select, MenuItem, FormControl, InputLabel, useTheme } from '@mui/material';
import { styled } from '@mui/system';

// 1. Usar styled para crear un componente con estilos
const SelectContainer = styled('div')({
  display: 'flex',
  gap: '20px',
  '@media (max-width:600px)': {
    flexDirection: 'column'
  }
});
function TipificacionEasy({ data , onChange,onSelectsChange,seleccionesIniciales}) {
  const rootOptions = useMemo(() => data.filter(item => item.padre === null), [data]);
  const [rootLabel] = useState(rootOptions.length > 0 ? rootOptions[0].label : "Root Select");

  const [selects, setSelects] = useState([{
    options: rootOptions,
    selected: "",
  }]);

  const lastSelect = selects[selects.length - 1];

useEffect(() => {
    const newSelects = [...selects];

    if (lastSelect.selected) {
        const newOptions = data.filter(item => item.padre === lastSelect.selected);
        if (newOptions.length > 0) {
            newSelects.push({ options: newOptions, selected: "" });
        }
    }

    setSelects(newSelects);

    if (onSelectsChange) {
        onSelectsChange(newSelects);
    }
}, [data, lastSelect.selected]);

  const handleChange = (index) => (event) => {
    const newSelects = [...selects];
    newSelects[index].selected = event.target.value;
    // Eliminar todos los selects después de este
    newSelects.splice(index + 1);
    setSelects(newSelects);

    const selectedOption = newSelects[index].options.find(option => option.id === event.target.value);
    if (selectedOption && onChange) {
      onChange(selectedOption);
    }
    if (onSelectsChange) {
      onSelectsChange(newSelects); // Ahora pasa newSelects
    }
    
  };

  return (
    <SelectContainer>
      {selects.map((select, index) => {
        const label = index === 0 ? rootLabel : select.options.find(option => option.id === select.selected)?.label;
        return (
          <FormControl key={index} style={{ minWidth: 150 ,}}>
            <InputLabel>{label}</InputLabel>
            <Select value={select.selected} onChange={handleChange(index)} label={label}>
              {select.options.map((item) => (
                <MenuItem key={item.id} value={item.id}>{item.tipificacion}</MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      })}
    </SelectContainer>
  );
}
export default TipificacionEasy;
